import PropTypes from 'prop-types';
import { memo, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { SearchStatus, SearchModeLabel } from '../../constants';
import MarkdownToHtml from '../MarkdownToHtml';

const TravelBlurbs = ({ type }) => {
  const { travelAgency } = useSelector((store) => store.user);
  const { selectedSearchMode, searchResult, searchStatus } = useSelector(
    (store) => store.tripSearch,
  );
  const blurbType = type || SearchModeLabel[+(selectedSearchMode || '0')].toLowerCase();
  const blurbs = useMemo(() => {
    const result = [];
    if (travelAgency && travelAgency.settings && travelAgency.settings.resultsPageBlurbs) {
      if (travelAgency.settings.resultsPageBlurbs[blurbType]) {
        result.push(travelAgency.settings.resultsPageBlurbs[blurbType]);
      }

      if (travelAgency.settings.resultsPageBlurbs.all) {
        result.push(`${travelAgency.settings.resultsPageBlurbs.all}`);
      }
    }
    return result;
  }, [travelAgency, blurbType]);

  return blurbs.length > 0 &&
    searchStatus === SearchStatus.DONE &&
    searchResult &&
    searchResult.total > 0 ? (
    blurbs.map((blurb) => (
      <MarkdownToHtml
        content={blurb}
        key={blurb}
        className="bg-orange-200 px-4 py-2 rounded-lg border border-orange-400 min-w-full mb-4 text-black"
      />
    ))
  ) : (
    <></>
  );
};

TravelBlurbs.propTypes = {
  type: PropTypes.string,
};

TravelBlurbs.defaultProps = {
  type: undefined,
};

export default memo(TravelBlurbs);
